import * as React from 'react'

import FormDropdown, { FormStyles } from 'embed/components/FormDropdown'
import {
  DepositAmountIntentRangeOptions,
  DEPOSITS_AMOUNT_INTENT_RANGE_FILTER_LIST,
  DropdownItem,
} from 'embed/constants'
import { Filter } from 'even-ts-static'
export interface Props {
  containerClass?: string
  items?: DropdownItem<string>[]
  hidden?: boolean
  onChange?: (fieldName: string, value: string, isValid: boolean) => void
  styles: FormStyles
  startingValue?: string
  value?: DropdownItem<string>
}

const Render: React.SFC<Props> = ({ containerClass, hidden, items, onChange, startingValue, styles, value }) => {
  React.useEffect(() => {
    onChange?.(Filter.DepositAmountIntentRange, DepositAmountIntentRangeOptions.LESS_THAN_1000, true)
  }, [])

  return !hidden ? (
    <FormDropdown
      containerClass={containerClass}
      fieldName={Filter.DepositAmountIntentRange}
      items={items || DEPOSITS_AMOUNT_INTENT_RANGE_FILTER_LIST}
      label="Deposit Amount"
      onChange={onChange}
      startingValue={startingValue}
      styles={styles}
      currentValue={value}
    />
  ) : null
}

Render.defaultProps = {
  containerClass: '',
  onChange: () => null,
  styles: {
    dropDown: '',
    dropDownLabel: '',
    fieldError: '',
  },
}

export default Render
